/* MCJ Smart Search — instant, typo-tolerant product search (desktop + mobile).
   Idle (focused/empty): Recent searches + Popular searches + Trending products.
   Typing: instant fuzzy results from the live catalog (all active, paged + cached).
   Voice: tap mic to start/stop; live transcript appears in the bar instantly; auto-stops
   after silence or 10s max; a clear listening indicator shows while active.
   Animation rule: the rotating keyword placeholder shows ONLY when idle (not focused,
   empty, and not listening); it is force-hidden while voice is listening. */
(function () {
  'use strict';
  var PAGE = 250, MAXPAGES = 12, CKEY = 'mcj_catalog_v2', CTTL = 1800000, RKEY = 'mcj_recent_searches';
  var VOICE_MAX_MS = 10000;
  var products = null, loading = null, trending = null, tload = null;

  function injectCss() {
    if (document.getElementById('mcj-ss-css')) return;
    var s = document.createElement('style'); s.id = 'mcj-ss-css';
    s.textContent =
      '.header_search .popup-search.popup-search-form{display:none !important;}' +
      'body.mcj-ss-active .bls__overlay{opacity:0 !important;visibility:hidden !important;}' +
      '.mcj-search-anim.mcj-hidden{display:none !important;}' +
      '.search-modal__form .field:focus-within .mcj-search-anim,.header_search .field:focus-within .mcj-search-anim{display:none !important;}' +
      'body.mcj-listening .mcj-search-anim{display:none !important;}' +
      '.mcj-listening-field .search__input{box-shadow:0 0 0 2px rgba(221,51,39,.45) !important;transition:box-shadow .2s ease;}' +
      '.mcj-mic-btn.listening{color:#dd3327 !important;}' +
      '.mcj-ss-panel{position:absolute;z-index:100020;background:#fff;border:1px solid #ece6da;border-radius:12px;box-shadow:0 16px 40px rgba(10,16,51,.20);overflow:auto;max-height:74vh;display:none;-webkit-overflow-scrolling:touch;}' +
      '.mcj-ss-panel.open{display:block;}' +
      '.mcj-ss-item{display:flex;gap:12px;align-items:center;padding:9px 14px;text-decoration:none;color:#0a1033;border-bottom:1px solid #f3eee2;}' +
      '.mcj-ss-item:hover{background:#faf6ee;}' +
      '.mcj-ss-img{width:46px;height:46px;border-radius:8px;object-fit:cover;border:1px solid #eee;flex:0 0 auto;background:#f7f7f7;}' +
      '.mcj-ss-info{flex:1;min-width:0;display:flex;flex-direction:column;}' +
      '.mcj-ss-name{font-size:13.5px;font-weight:600;line-height:1.3;margin:0 0 3px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}' +
      '.mcj-ss-price{font-size:13px;color:#9c7569;font-weight:700;}' +
      '.mcj-ss-head{padding:11px 14px 5px;font-size:11px;letter-spacing:.06em;text-transform:uppercase;color:#9aa0a6;font-weight:700;display:flex;justify-content:space-between;align-items:center;}' +
      '.mcj-ss-clear{font-size:11px;color:#9E1B32;cursor:pointer;font-weight:700;text-transform:none;letter-spacing:0;}' +
      '.mcj-ss-chips{display:flex;flex-wrap:wrap;gap:8px;padding:2px 14px 12px;}' +
      '.mcj-ss-chip{border:1px solid #e3d3ad;background:#fff;color:#0a1033;border-radius:20px;padding:6px 13px;font-size:12.5px;font-weight:600;cursor:pointer;font-family:inherit;line-height:1.2;}' +
      '.mcj-ss-chip:hover{background:#faf6ee;border-color:#c9a86a;}' +
      '.mcj-ss-all{display:block;padding:12px 14px;text-align:center;font-weight:700;font-size:13px;color:#9E1B32;text-decoration:none;border-top:1px solid #f0e9da;}' +
      '.mcj-ss-empty{padding:16px 14px;text-align:center;color:#6b7280;font-size:13px;}' +
      '.mcj-ss-voice{display:flex;align-items:center;gap:10px;padding:12px 14px;border-bottom:1px solid #f3eee2;color:#9E1B32;font-size:13px;font-weight:600;}' +
      '.mcj-ss-eq{display:inline-flex;align-items:flex-end;gap:3px;height:16px;flex:0 0 auto;}' +
      '.mcj-ss-eq i{display:block;width:3px;height:4px;background:#dd3327;border-radius:2px;animation:mcjEq .9s ease-in-out infinite;}' +
      '.mcj-ss-eq i:nth-child(2){animation-delay:.15s}.mcj-ss-eq i:nth-child(3){animation-delay:.3s}.mcj-ss-eq i:nth-child(4){animation-delay:.45s}.mcj-ss-eq i:nth-child(5){animation-delay:.6s}' +
      '@keyframes mcjEq{0%,100%{height:4px}50%{height:16px}}' +
      '.mcj-ss-voice-stop{margin-left:auto;color:#6b7280;font-weight:700;text-transform:uppercase;letter-spacing:.05em;font-size:11px;cursor:pointer;}' +
      '@media(max-width:989px){.mcj-ss-panel{position:fixed !important;left:8px !important;right:8px !important;width:auto !important;}}';
    document.head.appendChild(s);
  }

  function norm(s) { return ('' + (s || '')).toLowerCase().replace(/[^a-z0-9\s]+/g, ' ').replace(/\s+/g, ' ').trim(); }
  function titleCase(s) { return ('' + s).replace(/\b\w/g, function (c) { return c.toUpperCase(); }); }

  function fetchAll() {
    var all = [], page = 1;
    function next() {
      return fetch('/products.json?limit=' + PAGE + '&page=' + page, { cache: 'no-store', credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (d) { var arr = (d && d.products) || []; all = all.concat(arr); if (arr.length === PAGE && page < MAXPAGES) { page++; return next(); } return all; });
    }
    return next();
  }
  function build(raw) {
    return raw.map(function (p) {
      var v = (p.variants && p.variants[0]) || {};
      var img = (p.images && p.images[0] && p.images[0].src) || '';
      var tags = (p.tags || []).join(' ');
      var hay = norm(p.title + ' ' + (p.product_type || '') + ' ' + tags + ' ' + (p.vendor || ''));
      return { t: p.title, h: p.handle, pr: v.price || '', im: img, ty: norm(p.product_type || ''), hay: hay, flat: hay.replace(/\s/g, ''), words: hay.split(' ') };
    });
  }
  function load() {
    if (products) return Promise.resolve(products);
    if (loading) return loading;
    try { var c = JSON.parse(sessionStorage.getItem(CKEY) || 'null'); if (c && c.ts && (Date.now() - c.ts) < CTTL && c.items) { products = c.items; return Promise.resolve(products); } } catch (e) {}
    loading = fetchAll().then(function (raw) { products = build(raw); try { sessionStorage.setItem(CKEY, JSON.stringify({ ts: Date.now(), items: products })); } catch (e) {} return products; }).catch(function () { products = []; return products; });
    return loading;
  }
  function loadTrending() {
    if (trending) return Promise.resolve(trending);
    if (tload) return tload;
    tload = fetch('/collections/trending/products.json?limit=8', { cache: 'no-store', credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : {}; })
      .then(function (d) { var arr = (d && d.products) || []; trending = arr.length ? build(arr).slice(0, 6) : (products || []).slice(0, 6); return trending; })
      .catch(function () { trending = (products || []).slice(0, 6); return trending; });
    return tload;
  }

  function getRecents() { try { return JSON.parse(localStorage.getItem(RKEY) || '[]'); } catch (e) { return []; } }
  function setRecents(a) { try { localStorage.setItem(RKEY, JSON.stringify(a.slice(0, 6))); } catch (e) {} }
  function addRecent(t) { t = ('' + t).trim(); if (t.length < 2) return; var a = getRecents().filter(function (x) { return x.toLowerCase() !== t.toLowerCase(); }); a.unshift(t); setRecents(a); }
  function popularTerms() {
    var fallback = ['Rings', 'Earrings', 'Bracelets', 'Bangles', 'Gold Coins', 'Mangalsutra'];
    if (!products) return fallback;
    var counts = {}, i; for (i = 0; i < products.length; i++) { var ty = products[i].ty; if (ty) counts[ty] = (counts[ty] || 0) + 1; }
    var arr = Object.keys(counts).sort(function (a, b) { return counts[b] - counts[a]; });
    if (arr.length < 3) return fallback;
    return arr.slice(0, 6).map(titleCase);
  }

  function dl(a, b) {
    var m = a.length, n = b.length; if (Math.abs(m - n) > 4) return 9;
    var d = [], i, j; for (i = 0; i <= m; i++) { d[i] = []; d[i][0] = i; } for (j = 0; j <= n; j++) d[0][j] = j;
    for (i = 1; i <= m; i++) for (j = 1; j <= n; j++) {
      var cost = a.charCodeAt(i - 1) === b.charCodeAt(j - 1) ? 0 : 1;
      d[i][j] = Math.min(d[i - 1][j] + 1, d[i][j - 1] + 1, d[i - 1][j - 1] + cost);
      if (i > 1 && j > 1 && a.charCodeAt(i - 1) === b.charCodeAt(j - 2) && a.charCodeAt(i - 2) === b.charCodeAt(j - 1)) d[i][j] = Math.min(d[i][j], d[i - 2][j - 2] + 1);
    }
    return d[m][n];
  }
  function thr(len) { return len <= 4 ? 1 : len <= 7 ? 2 : 3; }
  function score(q, p) {
    if (!q) return 0;
    if (p.hay.indexOf(q) > -1) return 900 + (p.hay.indexOf(q) === 0 ? 100 : 0);
    var qf = q.replace(/\s/g, ''); if (qf.length >= 3 && p.flat.indexOf(qf) > -1) return 760;
    var qw = q.split(' '), need = 0, matched = 0, fuzzy = 0;
    for (var k = 0; k < qw.length; k++) {
      var w = qw[k]; if (!w) continue; need++;
      if (w.length < 2) { matched++; continue; }
      var exact = false; for (var x = 0; x < p.words.length; x++) { if (p.words[x].indexOf(w) > -1) { exact = true; break; } }
      if (exact) { matched++; continue; }
      var t = thr(w.length), best = 99, bw = '';
      for (var y = 0; y < p.words.length; y++) { var ww = p.words[y]; if (Math.abs(ww.length - w.length) > t + 1) continue; var dd = dl(w, ww); if (dd < best) { best = dd; bw = ww; } if (best === 0) break; }
      if (best <= t && (best <= 1 || (bw && bw.charAt(0) === w.charAt(0)))) fuzzy++;
    }
    if (need === 0) return 0;
    if (matched + fuzzy >= need) return 320 + matched * 40 - fuzzy * 6;
    if (matched > 0) return 100 + matched * 40 - (need - matched) * 12;
    if (fuzzy > 0) return 60 + fuzzy * 20;
    return 0;
  }
  function doSearch(q) {
    if (!products) return [];
    var out = []; for (var i = 0; i < products.length; i++) { var s = score(q, products[i]); if (s > 0) out.push([s, products[i]]); }
    out.sort(function (a, b) { return b[0] - a[0]; });
    return out.slice(0, 6).map(function (x) { return x[1]; });
  }

  function esc(s) { s = '' + (s || ''); return s.split('&').join('&amp;').split('<').join('&lt;').split('>').join('&gt;').split('"').join('&quot;'); }
  function fmtPrice(p) { var n = Number(p); if (!p || isNaN(n)) return ''; return '₹' + n.toLocaleString('en-IN'); }
  function thumb(src) { if (!src) return ''; return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=96'; }
  function itemHtml(p) { return '<a class="mcj-ss-item" href="/products/' + encodeURIComponent(p.h) + '"><img class="mcj-ss-img" loading="lazy" src="' + esc(thumb(p.im)) + '" alt=""><span class="mcj-ss-info"><span class="mcj-ss-name">' + esc(p.t) + '</span><span class="mcj-ss-price">' + fmtPrice(p.pr) + '</span></span></a>'; }
  function chip(label) { return '<button type="button" class="mcj-ss-chip" data-term="' + esc(label) + '">' + esc(label) + '</button>'; }
  function voiceBanner() { return '<div class="mcj-ss-voice"><span class="mcj-ss-eq"><i></i><i></i><i></i><i></i><i></i></span><span>Listening…</span><span class="mcj-ss-voice-stop" data-voicestop="1">Stop</span></div>'; }

  function renderResults(panel, q, res, listening) {
    var h = listening ? voiceBanner() : '';
    if (!res.length) { h += '<div class="mcj-ss-empty">No matches for “' + esc(q) + '”</div><a class="mcj-ss-all" href="/search?q=' + encodeURIComponent(q) + '">Search the whole store →</a>'; }
    else { h += '<div class="mcj-ss-head">Products</div>'; for (var i = 0; i < res.length; i++) h += itemHtml(res[i]); h += '<a class="mcj-ss-all" href="/search?q=' + encodeURIComponent(q) + '">View all results →</a>'; }
    panel.innerHTML = h; panel.classList.add('open');
  }
  function renderIdle(panel, listening) {
    var h = listening ? voiceBanner() : '';
    var rec = getRecents();
    if (rec.length) { h += '<div class="mcj-ss-head">Recent Searches<span class="mcj-ss-clear" data-clear="1">Clear</span></div><div class="mcj-ss-chips">'; for (var i = 0; i < rec.length; i++) h += chip(rec[i]); h += '</div>'; }
    var pop = popularTerms();
    if (pop.length) { h += '<div class="mcj-ss-head">Popular Searches</div><div class="mcj-ss-chips">'; for (var j = 0; j < pop.length; j++) h += chip(pop[j]); h += '</div>'; }
    h += '<div class="mcj-ss-head">Trending</div><div class="mcj-ss-trending"></div>';
    panel.innerHTML = h; panel.classList.add('open');
    loadTrending().then(function (tr) { var c = panel.querySelector('.mcj-ss-trending'); if (!c) return; var hh = ''; (tr || []).forEach(function (p) { hh += itemHtml(p); }); c.innerHTML = hh; });
  }

  function place(input, panel) {
    var r = input.getBoundingClientRect();
    if (window.innerWidth > 989) { panel.style.position = 'absolute'; panel.style.top = (window.pageYOffset + r.bottom + 6) + 'px'; panel.style.left = (window.pageXOffset + r.left) + 'px'; panel.style.width = Math.max(r.width, 340) + 'px'; panel.style.right = 'auto'; }
    else { panel.style.position = 'fixed'; panel.style.top = (r.bottom + 6) + 'px'; panel.style.left = '8px'; panel.style.right = '8px'; panel.style.width = 'auto'; }
  }

  function attach(input) {
    if (input.__mcjSS) return input.__mcjPanel; input.__mcjSS = 1;
    injectCss();
    var panel = document.createElement('div'); panel.className = 'mcj-ss-panel'; document.body.appendChild(panel);
    input.__mcjPanel = panel;
    var fld = input.closest('.field');
    var animEl = fld ? fld.querySelector('.mcj-search-anim') : null;
    function setAnim() { if (!animEl) return; var active = input.__mcjListening || (document.activeElement === input) || input.value.trim().length > 0; animEl.classList.toggle('mcj-hidden', active); }
    input.__mcjSetAnim = setAnim;
    function closePanel() { panel.classList.remove('open'); setAnim(); }
    input.__mcjClose = closePanel;
    var deb;
    function run() {
      if (document.activeElement !== input && !input.__mcjListening) { closePanel(); return; }
      var q = input.value.trim();
      place(input, panel);
      var listening = input.__mcjListening;
      if (q.length < 2) { load().then(function () { if (document.activeElement !== input && !input.__mcjListening) { closePanel(); return; } renderIdle(panel, input.__mcjListening); setAnim(); }); setAnim(); return; }
      clearTimeout(deb);
      deb = setTimeout(function () { load().then(function () { if (document.activeElement !== input && !input.__mcjListening) { closePanel(); return; } var qq = input.value.trim(); if (qq.length < 2) { renderIdle(panel, input.__mcjListening); setAnim(); return; } place(input, panel); renderResults(panel, qq, doSearch(norm(qq)), input.__mcjListening); setAnim(); }); }, 120);
      setAnim();
    }
    input.__mcjRun = run;
    input.addEventListener('input', run);
    input.addEventListener('focus', function () { document.body.classList.add('mcj-ss-active'); load(); run(); setAnim(); });
    input.addEventListener('blur', function () { setTimeout(function () { var ae = document.activeElement; if (ae !== input && !(panel.contains && panel.contains(ae))) { document.body.classList.remove('mcj-ss-active'); panel.classList.remove('open'); } setAnim(); }, 200); });
    input.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closePanel(); } else if (e.key === 'Enter') { var q = input.value.trim(); if (q.length >= 2) addRecent(q); } });
    panel.addEventListener('click', function (e) {
      var vs = e.target.closest('[data-voicestop]'); if (vs) { e.preventDefault(); if (input.__mcjStopVoice) input.__mcjStopVoice(); return; }
      var clr = e.target.closest('[data-clear]'); if (clr) { e.preventDefault(); setRecents([]); renderIdle(panel, input.__mcjListening); input.focus(); return; }
      var ch = e.target.closest('[data-term]'); if (ch) { e.preventDefault(); var t = ch.getAttribute('data-term'); addRecent(t); input.value = t; input.focus(); run(); return; }
      var it = e.target.closest('.mcj-ss-item, .mcj-ss-all'); if (it) { var q = input.value.trim(); if (q.length >= 2) addRecent(q); }
    });
    document.addEventListener('click', function (e) { if (e.target !== input && !panel.contains(e.target) && !(e.target.closest && e.target.closest('.mcj-mic-btn'))) { closePanel(); } });
    window.addEventListener('scroll', function () { if (panel.classList.contains('open')) place(input, panel); }, { passive: true });
    window.addEventListener('resize', function () { if (panel.classList.contains('open')) place(input, panel); });
    setAnim();
    return panel;
  }

  function setupVoice() {
    var SR = window.SpeechRecognition || window.webkitSpeechRecognition;
    var btns = document.querySelectorAll('.mcj-mic-btn');
    if (!SR) { btns.forEach(function (b) { b.style.display = 'none'; }); return; }
    btns.forEach(function (orig) {
      if (orig.__mcjVoice) return;
      var btn = orig.cloneNode(true); btn.__mcjVoice = 1;
      if (orig.parentNode) orig.parentNode.replaceChild(btn, orig);
      var form = btn.closest('form');
      var input = (form && form.querySelector('.search__input, input[name="q"]')) || document.querySelector('input[name="q"]');
      if (!input) return;
      attach(input);
      var fld = input.closest('.field') || form;
      var rec = new SR();
      rec.continuous = false; rec.interimResults = true; rec.lang = 'en-IN'; rec.maxAlternatives = 1;
      var prevPh = input.getAttribute('placeholder') || '';
      function clearTimer() { if (input.__mcjVoiceTimer) { clearTimeout(input.__mcjVoiceTimer); input.__mcjVoiceTimer = null; } }
      function stopListenUI() { input.__mcjListening = false; if (window.__mcjRec === rec) window.__mcjRec = null; clearTimer(); btn.classList.remove('listening'); if (fld) fld.classList.remove('mcj-listening-field'); document.body.classList.remove('mcj-listening'); input.setAttribute('placeholder', prevPh); btn.setAttribute('aria-label', 'Search by voice'); if (input.__mcjSetAnim) input.__mcjSetAnim(); }
      input.__mcjStopVoice = function () { try { rec.stop(); } catch (e) {} };
      btn.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        if (input.__mcjListening) { try { rec.stop(); } catch (er) {} return; }
        if (window.__mcjRec && window.__mcjRec !== rec) { try { window.__mcjRec.stop(); } catch (er) {} }
        try { rec.start(); } catch (err) {}
      });
      rec.onstart = function () {
        input.__mcjListening = true; window.__mcjRec = rec;
        btn.classList.add('listening'); btn.setAttribute('aria-label', 'Listening, tap to stop');
        if (fld) fld.classList.add('mcj-listening-field');
        document.body.classList.add('mcj-listening');
        try { input.focus(); } catch (e) {}
        input.setAttribute('placeholder', 'Listening…');
        clearTimer();
        input.__mcjVoiceTimer = setTimeout(function () { try { rec.stop(); } catch (e) {} }, VOICE_MAX_MS);
        if (input.__mcjSetAnim) input.__mcjSetAnim();
        if (input.__mcjRun) input.__mcjRun();
      };
      rec.onresult = function (ev) {
        var txt = ''; for (var i = 0; i < ev.results.length; i++) txt += ev.results[i][0].transcript;
        txt = txt.replace(/\s+/g, ' ').trim();
        if (txt) { input.value = txt; if (input.__mcjSetAnim) input.__mcjSetAnim(); if (input.__mcjRun) input.__mcjRun(); }
      };
      rec.onerror = function (ev) {
        stopListenUI();
        if (ev.error === 'not-allowed' || ev.error === 'service-not-allowed') alert('Please allow microphone access to use voice search.');
      };
      rec.onend = function () {
        stopListenUI();
        var q = input.value.trim(); if (q.length >= 2) { addRecent(q); }
        if (input.__mcjRun) input.__mcjRun();
      };
    });
  }

  function init() {
    injectCss();
    document.querySelectorAll('input[name="q"]').forEach(function (i) { if (i.offsetParent !== null) attach(i); });
    document.addEventListener('focusin', function (e) { var i = e.target; if (i && i.matches && i.matches('input[name="q"]')) attach(i); });
    setupVoice();
    load();
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
